module.exports = __webpack_public_path__ + "media/images/user-m-8374a83a6b704355c632e78258e1b969.svg";